import { render, staticRenderFns } from "./ScreenConfigure.vue?vue&type=template&id=7104e44a&scoped=true&"
import script from "./ScreenConfigure.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigure.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConfigure.vue?vue&type=style&index=0&id=7104e44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104e44a",
  null
  
)

export default component.exports